<template>
   <div class="form-group col-md-6">
        <label for="contact" class="mb-0"> {{ $t('contact') }} </label>
        <app-input 
            id="contact" 
            class="form-control" 
            :placeholder="$t('select_contact')"
            type="advance-search-select"
            :fetch-url='`/getContacts/${contact_id}`'
            v-model="selected" 
            listValueField="name" 
            :loaded-per-time="5"
        />
    </div>
</template>

<script>
    export default {
        name: 'contactAddress',
        props: {
            value: {
                type: [String, Number, Object],
                default: null
            },
            contact_id :{
                type: [String, Number, Object],
                default: null
            }
        },
        computed: {
            selected: {
                get() {
                    return this.value;
                },
                set(newValue) {
                    this.$emit('input', newValue);
                }
            }
        }
    }
</script>
